// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body_zW55m {
  font-family: 'Arial', sans-serif;
  margin: 20px;
  padding: 10px;
  background-color: #fff;
  width: 25cm;
  height: 29.7cm;
  margin-bottom: 30px;
}
.printableContent_Xm3gS {
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
}
.col_sm_W6IPn {
  width: 100%;
}
.hedertext_cjy_B {
  padding: 0 64px;
}
.hedertextCompanyName_AtLg7 {
  font-size: 15px;
  color: #2961af;
}
.headersmalltext_qIous {
  font-size: 10px;
  color: #969997;
}
.headerlogo_MfYoy {
  float: right;
  width: 150px;
  height: 80px;
  top: 0;
  position: static;
  object-fit: contain;
}
.headerContainer_W7fAc {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title_sixR_ {
  font-size: 30px;
  color: #2961af;
  font-weight: 700;
}
.hrstyle_Zeeo3 {
  height: 2px;
  background: #000;
}
.hrstyle2_kghLa {
  height: 0.5px;
  background: #000;
}
.subtotal_Vat_XUJyp {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.strongText_IVB8Z {
  text-align: 'left';
}
.ptext_GlYsu {
  text-align: right;
  margin: 0;
}
.annually_montly_vIaSo {
  display: 'block';
}
.button_PY5yP {
  margin-top: 30px;
}
@media print {
  body,
  div[data-size='A4'] {
    margin: 0;
    box-shadow: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Clients/RegisteredClients/SoleTrader/Buttons/Compliance/QuotationPreview/customcss.less"],"names":[],"mappings":"AAAA;EACI,gCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AACJ;AACA;EACI,cAAA;EACA,cAAA;EACA,oBAAA;AACJ;AACA;EACI,WAAA;AACJ;AAEA;EACI,eAAA;AAAJ;AAEA;EACI,eAAA;EACA,cAAA;AAAJ;AAEA;EACI,eAAA;EACA,cAAA;AAAJ;AAEA;EACI,YAAA;EACA,YAAA;EACA,YAAA;EACA,MAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;AAEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAAJ;AAGA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AADJ;AAGA;EACI,WAAA;EACA,gBAAA;AADJ;AAGA;EACI,aAAA;EACA,gBAAA;AADJ;AAGA;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;AADJ;AAGA;EACI,kBAAA;AADJ;AAGA;EACI,iBAAA;EACA,SAAA;AADJ;AAGA;EACI,gBAAA;AADJ;AAIA;EACI,gBAAA;AAFJ;AAIA;EACI;;IAEI,SAAA;IACA,aAAA;EAFN;AACF","sourcesContent":[".body {\n    font-family: 'Arial', sans-serif;\n    margin: 20px;\n    padding: 10px;\n    background-color: #fff;\n    width: 25cm;\n    height: 29.7cm;\n    margin-bottom: 30px;\n}\n.printableContent {\n    display: block;\n    margin: 0 auto;\n    margin-bottom: 0.5cm;\n}\n.col_sm {\n    width: 100%;\n}\n\n.hedertext {\n    padding: 0 64px;\n}\n.hedertextCompanyName {\n    font-size: 15px;\n    color: #2961af;\n}\n.headersmalltext {\n    font-size: 10px;\n    color: #969997;\n}\n.headerlogo {\n    float: right;\n    width: 150px;\n    height: 80px;\n    top: 0;\n    position: static;\n    object-fit: contain;\n}\n.headerContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.title {\n    font-size: 30px;\n    color: #2961af;\n    font-weight: 700;\n}\n.hrstyle {\n    height: 2px;\n    background: #000;\n}\n.hrstyle2 {\n    height: 0.5px;\n    background: #000;\n}\n.subtotal_Vat {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n}\n.strongText {\n    text-align: 'left';\n}\n.ptext {\n    text-align: right;\n    margin: 0;\n}\n.annually_montly {\n    display: 'block';\n}\n\n.button {\n    margin-top: 30px;\n}\n@media print {\n    body,\n    div[data-size='A4'] {\n        margin: 0;\n        box-shadow: 0;\n    }\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `body_zW55m`,
	"printableContent": `printableContent_Xm3gS`,
	"col_sm": `col_sm_W6IPn`,
	"hedertext": `hedertext_cjy_B`,
	"hedertextCompanyName": `hedertextCompanyName_AtLg7`,
	"headersmalltext": `headersmalltext_qIous`,
	"headerlogo": `headerlogo_MfYoy`,
	"headerContainer": `headerContainer_W7fAc`,
	"title": `title_sixR_`,
	"hrstyle": `hrstyle_Zeeo3`,
	"hrstyle2": `hrstyle2_kghLa`,
	"subtotal_Vat": `subtotal_Vat_XUJyp`,
	"strongText": `strongText_IVB8Z`,
	"ptext": `ptext_GlYsu`,
	"annually_montly": `annually_montly_vIaSo`,
	"button": `button_PY5yP`
};
export default ___CSS_LOADER_EXPORT___;
